import React from "react";
import { Link } from "react-router-dom";
import polarisLogo from "../images/Polaris Logo.svg";
import "../styles/legal-pages.css";

export function DataAccountDeletionPage() {
    return (
        <main className="legal-page">
            <header className="legal-header">
                <img src={polarisLogo} alt="Polaris Athlete" className="legal-logo" />
                <div className="legal-header-buttons">
                    <Link to="/signup" className="btn-signup">Sign up</Link>
                    <Link to="/login" className="btn-access">Access Account</Link>
                </div>
            </header>

            <div className="legal-content">
                <h1 className="legal-title">Data and Account Deletion</h1>

                <section className="legal-section">
                    <h2>Delete My Account</h2>
                    <p className="legal-subtitle">Polaris Athlete LLC – Account Deletion Instructions</p>
                    <p>We respect your privacy and give you control over your personal information. You may request to delete your account and associated data at any time.</p>
                </section>

                <section className="legal-section">
                    <h2>How to Delete Your Account</h2>

                    <h3>1. Log In</h3>
                    <p>Sign in to your Polaris Athlete account using your email and password.</p>

                    <h3>2. Navigate to Profile (icon in the upper right)</h3>
                    <p>Select, the edit icon and select "Delete Account"</p>

                    <h3>3. Confirm Deletion</h3>
                    <p>Follow the prompts to confirm that you want to permanently delete your account.</p>
                    <p>You may be asked to:</p>
                    <ul>
                        <li>Enter your password</li>
                        <li>Confirm that you understand this action is irreversible after 30 days. Polaris Athlete LLC will store your information for 30 days during a reactivation period and all information thereafter is permanently deleted from our system.</li>
                    </ul>

                    <h3>4. Request via Support (Optional)</h3>
                    <p>If you cannot access your account, you can request deletion by emailing <a href="mailto:support@polarisathlete.com" className="legal-inline-link">support@polarisathlete.com</a>. Please include:</p>
                    <ul>
                        <li>Full name</li>
                        <li>Email address associated with your account</li>
                        <li>A clear request to delete your account</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>What Happens After Deletion</h2>
                    <ul>
                        <li>Your account will be deactivated immediately.</li>
                        <li>Personal data will be retained for up to 30 days in case you decide to reactivate your account.</li>
                        <li>After the 30-day reactivation period, all your personal data, including account details, recordings, and session history, will be permanently deleted from our servers, unless retention is required by law.</li>
                        <li>Content generated by you that is shared with mentors or staff (for example, consultation notes) will be anonymized or removed as appropriate to maintain platform integrity.</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>Important Notes</h2>
                    <ul>
                        <li><strong>Recorded Consultations:</strong> Any recordings made with consent will be removed from your account upon deletion.</li>
                        <li><strong>Third-Party Services:</strong> Some data processed through Stripe or other service providers may be retained temporarily for legal or financial compliance.</li>
                        <li><strong>No Refunds:</strong> Deleting your account does not automatically trigger a refund. Please review our Refund Policy or contact support@polarisathlete.com for assistance.</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>Questions or Support</h2>
                    <p>If you have questions or encounter any issues with account deletion, contact us at:</p>
                    <p>📧 <a href="mailto:support@polarisathlete.com" className="legal-email">support@polarisathlete.com</a> 🌐 <a href="https://www.polarisathlete.com" target="_blank" rel="noopener noreferrer" className="legal-link">www.polarisathlete.com</a></p>
                    <ul>
                        <li>We are committed to ensuring your data privacy and supporting you through the account deletion process.</li>
                    </ul>
                </section>
            </div>

            <footer className="legal-footer">
                <p>© 2026 Polaris Athlete LLC. All rights reserved.</p>
                <div className="legal-footer-links">
                    <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    <span className="separator">|</span>
                    <a href="/terms" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
                    <span className="separator">|</span>
                    <a href="/data" target="_blank" rel="noopener noreferrer">Data & Account Deletion</a>
                    <span className="separator">|</span>
                    <a href="mailto:support@polarisathlete.com">Contact Us</a>
                </div>
                <div className="legal-footer-contact">
                    <a href="mailto:support@polarisathlete.com" className="support-email">support@polarisathlete.com</a>
                </div>
            </footer>
        </main>
    );
}

export default DataAccountDeletionPage;

